import { render, staticRenderFns } from "./ex-company.vue?vue&type=template&id=315d0e16&scoped=true&"
import script from "./ex-company.vue?vue&type=script&lang=js&"
export * from "./ex-company.vue?vue&type=script&lang=js&"
import style0 from "./ex-company.vue?vue&type=style&index=0&id=315d0e16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d0e16",
  null
  
)

export default component.exports